import CancelIcon from '@eduzz/houston-icons/Cancel';
import SearchOutlineIcon from '@eduzz/houston-icons/SearchOutline';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import React from 'react';

import { useStyles, StyledAutocomplete } from './styles';

export interface IAutocompleteOption {
  value: number;
  label: string;
}

interface Props {
  options: IAutocompleteOption[];
  selectedOptions: IAutocompleteOption[];
  onTagRemoveClick: (option: IAutocompleteOption) => void;
  onChange: (event: React.ChangeEvent<{}>, value: IAutocompleteOption[]) => void;
}

export const Autocomplete = ({ options = [], selectedOptions = [], onTagRemoveClick, onChange }: Props) => {
  const classes = useStyles();

  const renderTags = (options: IAutocompleteOption[]) => {
    return options.map((option) => (
      <div className={classes.autocompleteTag} key={option.value}>
        {option.value}
        <IconButton
          className={classes.autocompleteTagRemoveBtn}
          onClick={() => onTagRemoveClick(option)}
          aria-label='Fechar modal'
          size='small'
          disableRipple
        >
          <CancelIcon className={classes.autocompleteTagRemoveIcon} size={12} />
        </IconButton>
      </div>
    ));
  };

  return (
    <StyledAutocomplete
      multiple
      options={options}
      value={selectedOptions}
      getOptionLabel={(option: IAutocompleteOption) => option.label}
      renderInput={(params) => <TextField {...params} placeholder={!selectedOptions.length ? 'Buscar por nome ou ID do produto' : ''} />}
      onChange={onChange}
      renderTags={renderTags}
      popupIcon={<SearchOutlineIcon />}
    />
  );
};
